import _toConsumableArray from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BackSide, BoxGeometry, Mesh, MeshBasicMaterial, MeshStandardMaterial, PointLight, Scene } from 'three';
var legacy = {
  topLight: {
    intensity: 500,
    position: [0.418, 16.199, 0.300]
  },
  room: {
    position: [-0.757, 13.219, 0.717],
    scale: [31.713, 28.305, 28.591]
  },
  boxes: [{
    position: [-10.906, 2.009, 1.846],
    rotation: -0.195,
    scale: [2.328, 7.905, 4.651]
  }, {
    position: [-5.607, -0.754, -0.758],
    rotation: 0.994,
    scale: [1.970, 1.534, 3.955]
  }, {
    position: [6.167, 0.857, 7.803],
    rotation: 0.561,
    scale: [3.927, 6.285, 3.687]
  }, {
    position: [-2.017, 0.018, 6.124],
    rotation: 0.333,
    scale: [2.002, 4.566, 2.064]
  }, {
    position: [2.291, -0.756, -2.621],
    rotation: -0.286,
    scale: [1.546, 1.552, 1.496]
  }, {
    position: [-2.193, -0.369, -5.547],
    rotation: 0.516,
    scale: [3.875, 3.487, 2.986]
  }],
  lights: [{
    intensity: 50,
    position: [-16.116, 14.37, 8.208],
    scale: [0.1, 2.428, 2.739]
  }, {
    intensity: 50,
    position: [-16.109, 18.021, -8.207],
    scale: [0.1, 2.425, 2.751]
  }, {
    intensity: 17,
    position: [14.904, 12.198, -1.832],
    scale: [0.15, 4.265, 6.331]
  }, {
    intensity: 43,
    position: [-0.462, 8.89, 14.520],
    scale: [4.38, 5.441, 0.088]
  }, {
    intensity: 20,
    position: [3.235, 11.486, -12.541],
    scale: [2.5, 2.0, 0.1]
  }, {
    intensity: 100,
    position: [0.0, 20.0, 0.0],
    scale: [1.0, 0.1, 1.0]
  }]
};
var neutral = {
  topLight: {
    intensity: 400,
    position: [0.5, 14.0, 0.5]
  },
  room: {
    position: [0.0, 13.2, 0.0],
    scale: [31.5, 28.5, 31.5]
  },
  boxes: [{
    position: [-10.906, -1.0, 1.846],
    rotation: -0.195,
    scale: [2.328, 7.905, 4.651]
  }, {
    position: [-5.607, -0.754, -0.758],
    rotation: 0.994,
    scale: [1.970, 1.534, 3.955]
  }, {
    position: [6.167, -0.16, 7.803],
    rotation: 0.561,
    scale: [3.927, 6.285, 3.687]
  }, {
    position: [-2.017, 0.018, 6.124],
    rotation: 0.333,
    scale: [2.002, 4.566, 2.064]
  }, {
    position: [2.291, -0.756, -2.621],
    rotation: -0.286,
    scale: [1.546, 1.552, 1.496]
  }, {
    position: [-2.193, -0.369, -5.547],
    rotation: 0.516,
    scale: [3.875, 3.487, 2.986]
  }],
  lights: [{
    intensity: 80,
    position: [-14.0, 10.0, 8.0],
    scale: [0.1, 2.5, 2.5]
  }, {
    intensity: 80,
    position: [-14.0, 14.0, -4.0],
    scale: [0.1, 2.5, 2.5]
  }, {
    intensity: 23,
    position: [14.0, 12.0, 0.0],
    scale: [0.1, 5.0, 5.0]
  }, {
    intensity: 16,
    position: [0.0, 9.0, 14.0],
    scale: [5.0, 5.0, 0.1]
  }, {
    intensity: 80,
    position: [7.0, 8.0, -14.0],
    scale: [2.5, 2.5, 0.1]
  }, {
    intensity: 80,
    position: [-7.0, 16.0, -14.0],
    scale: [2.5, 2.5, 0.1]
  }, {
    intensity: 1,
    position: [0.0, 20.0, 0.0],
    scale: [0.1, 0.1, 0.1]
  }]
};
var EnvironmentScene = /*#__PURE__*/function (_Scene) {
  _inherits(EnvironmentScene, _Scene);
  var _super = _createSuper(EnvironmentScene);
  function EnvironmentScene(name) {
    var _mainLight$position, _room$position, _room$scale;
    var _this;
    _classCallCheck(this, EnvironmentScene);
    _this = _super.call(this);
    _this.position.y = -3.5;
    var geometry = new BoxGeometry();
    geometry.deleteAttribute('uv');
    var roomMaterial = new MeshStandardMaterial({
      metalness: 0,
      side: BackSide
    });
    var boxMaterial = new MeshStandardMaterial({
      metalness: 0
    });
    var data = name == 'legacy' ? legacy : neutral;
    var mainLight = new PointLight(0xffffff, data.topLight.intensity, 28, 2);
    (_mainLight$position = mainLight.position).set.apply(_mainLight$position, _toConsumableArray(data.topLight.position));
    _this.add(mainLight);
    var room = new Mesh(geometry, roomMaterial);
    (_room$position = room.position).set.apply(_room$position, _toConsumableArray(data.room.position));
    (_room$scale = room.scale).set.apply(_room$scale, _toConsumableArray(data.room.scale));
    _this.add(room);
    var _iterator = _createForOfIteratorHelper(data.boxes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _box1$position, _box1$scale;
        var box = _step.value;
        var box1 = new Mesh(geometry, boxMaterial);
        (_box1$position = box1.position).set.apply(_box1$position, _toConsumableArray(box.position));
        box1.rotation.set(0, box.rotation, 0);
        (_box1$scale = box1.scale).set.apply(_box1$scale, _toConsumableArray(box.scale));
        _this.add(box1);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(data.lights),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _light1$position, _light1$scale;
        var light = _step2.value;
        var light1 = new Mesh(geometry, _this.createAreaLightMaterial(light.intensity));
        (_light1$position = light1.position).set.apply(_light1$position, _toConsumableArray(light.position));
        (_light1$scale = light1.scale).set.apply(_light1$scale, _toConsumableArray(light.scale));
        _this.add(light1);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return _this;
  }
  _createClass(EnvironmentScene, [{
    key: "createAreaLightMaterial",
    value: function createAreaLightMaterial(intensity) {
      var material = new MeshBasicMaterial();
      material.color.setScalar(intensity);
      return material;
    }
  }]);
  return EnvironmentScene;
}(Scene);
export { EnvironmentScene as default };